export default __webpack_public_path__ + "static/media/halls-2.de8702f5.webp";